// extracted by mini-css-extract-plugin
module.exports = {"teamsContainer":"teams_teamsContainer__3q8Ul","teams":"teams_teams__3bp0_"};